// extracted by mini-css-extract-plugin
export var actionText = "_r6-4";
export var container = "_r6-0";
export var leftSection = "_r6-1";
export var rightSection = "_r6-2";
export var settingsButton = "_r6-6";
export var settingsIcon = "_r6-7";
export var shortcut = "_r6-5";
export var shortcutGroup = "_r6-3";